import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import commonFunctions from '../../../utils/commonFunctions';
import { SIGNAGE_MEDIA } from '../../../utils/constants';
import trashIcon from '../../../assets/icons/table/trash.svg';
import addCircle from '../../../assets/icons/signage-plus/add_circle.svg'

const TickerMessage = ({
  setSuccess,
  closeModal,
  setZoneData,
  tickerMessageData,
  zone,
  setZone,
  markUnsavedChanges
}) => {

  const [tickerMessage, setTickerMessage] = useState(['']);
  const [tickerMessageCheckReport, setTickerMessageCheckReport] = useState([]);
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const MAX_TICKER_MESSAGES = 7;
  const MAX_CHARACTERS = 256;
  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    setTickerMessage('');
    setTickerMessageCheckReport([]);
    setZone('');
  }

  useEffect(() => {
    const modalElement = document.getElementById('tickerMessageModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  useEffect(() => {
    if (zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER) return;
    if (tickerMessageData && tickerMessageData.content && tickerMessageData.content.message) {
      setTickerMessage(tickerMessageData.content.message);
      checkTickersFormat(tickerMessageData.content.message);
    } else {
      setTickerMessage(['']);
    }
  }, [tickerMessageData,zone]);
  
  const checkTickersFormat = (messages, index = null) => {
    const check = (value) => {
      const text = value.trim();
      // const isIncludeHtml = /<[a-z][\s\S]*>/i.test(text);
      return text.length >= 2 && text.length <= MAX_CHARACTERS/* && !isIncludeHtml*/;
    }

    // Check one line.
    if (index !== null) {
      const line = messages[0];
      const lineFlag = check(line);
      
      setTickerMessageCheckReport((prev) => [
        ...prev.slice(0, index),
        (lineFlag? '' : 'TICKER_MESSAGE_LENGTH'),
        ...prev.slice(index + 1)
      ]);
      return lineFlag;
    }
    
    // Check all line.
    let flag = true;
    const flagArr = [];
      for (const line of messages) {
      const lineFlag = check(line);
      flag = flag && lineFlag;
      flagArr.push(lineFlag? '' : 'TICKER_MESSAGE_LENGTH');
    }
    setTickerMessageCheckReport(flagArr);
    return flag;
  };

  /**
   * Handle form input change
   */
  const handleChange = useCallback((e, index) => {
    const value = e.target.value;
    const isValid = checkTickersFormat([value], index);
    if (value.length <= MAX_CHARACTERS) 
      setTickerMessage((prev) => [...prev.slice(0, index), value, ...prev.slice(index + 1)]);

    if (!isValid)
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
  }, []);

  const handleAdd = async () => {
    try {
      setZoneData((prevZoneData) => {
        const newZoneData = { ...prevZoneData };
        newZoneData[zone] = {
          zone: zone,
          content: {
            message: tickerMessage.map(item => item.trim())
          }
        };
        return newZoneData;
      });
      markUnsavedChanges && markUnsavedChanges();
      setSuccess(<FormattedMessage id="TICKER_MESSAGE_SUCCESS" />);
      closeModal("tickerMessageModal");
      resetModal();
    } catch (err) {
      setModalError(<FormattedMessage id="TICKER_MESSAGE_SUCCESS" values={{ errorMsg: <b>{err.message}</b> }} />);
    }
  };
  const handleAddSingleMessage = (e) => {
    e.preventDefault();
    setTickerMessage(prev => {
      if (!Array.isArray(prev))
        return [""];
      if (prev.length >= MAX_TICKER_MESSAGES)
        return prev;
      return [...prev, ""];
    });
    setTickerMessageCheckReport((prev) => [...prev, 'TICKER_MESSAGE_LENGTH']);
  };

  const handleRemoveSingleMessage = (e, index) => {
    e.preventDefault();
    setTickerMessage(prev => {
      if (!Array.isArray(prev) || index < 0 || index >= prev.length)
        return prev || [];
      return [...prev.slice(0, index), ...prev.slice(index + 1)];
    });
    setTickerMessageCheckReport((prev) => [...prev.slice(0, index), ...prev.slice(index + 1)]);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const isValid = checkTickersFormat(tickerMessage);
    if (!isValid) {
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
      return;
    }
    handleAdd();
  };

  return (
    <div className='modal modal-mse fade' id='tickerMessageModal' tabIndex='-1' aria-labelledby='tickerMessageModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='TICKER_MESSAGE' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='mb-2'>
                  <label htmlFor='typeMessageInput' className='font-weight-600 font-size-14 mb-2'>
                    <FormattedMessage id='TYPE_MESSAGE' />:
                  </label>&nbsp;&nbsp;
                  <FormattedMessage id="TICKER_MESSAGE_REMAINING_COUNT" values={{ count: MAX_TICKER_MESSAGES /*- tickerMessage.length*//*(bug#21486)*/ }} />
                  {(tickerMessage || []).map((message, index) => (
                    <div key={"divMessage_" + index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }} className='row'>
                      <div className='col-11'>
                        <input
                          id={"txtMessage_" + index}
                          key={"txtMessage_" + index}
                          onChange={(e) => handleChange(e, index)}
                          value={message}
                          name={"txtMessage_" + index}
                          placeholder={t('TYPE_MESSAGE')}
                          className={`form-control h-54 bg-baby-blue ${submitted && (tickerMessageCheckReport[index]!=='' ? 'is-invalid' : 'is-valid')}`}
                        />
                      </div>
                      <div className='col-1' hidden={index === 0}>
                        <button
                          className="btn"
                          id={"btnDeleteMessage_" + index}
                          key={"btnDeleteMessage_" + index}
                          onClick={(e) => handleRemoveSingleMessage(e, index)}
                        >
                          <img src={trashIcon} className="actionIcon deleteAction" alt={t("DELETE")} title={t("DELETE")} />
                        </button>
                      </div>
                      <div className='col-11'>
                        <div className={`${submitted && (tickerMessageCheckReport[index]!=='' ? 'is-invalid' : 'is-valid')}`} style={{display: 'none'}}></div>
                        {
                          !submitted || !tickerMessageCheckReport[index] ?
                          <div style={{ color: 'gray' }}><FormattedMessage id="CHARACTERS_REMAINING" values={{ count: MAX_CHARACTERS - tickerMessage[index].length }} /></div> :
                          commonFunctions.InvalidFeedbackString(tickerMessageCheckReport[index], 'TYPE_MESSAGE')
                        }
                      </div>
                      <div className='col-1'></div>
                    </div>
                  ))}
                  <button
                    className="btn"
                    id="btnAddMessage"
                    style={{display: 'flex', alignItems: 'center'}}
                    hidden={tickerMessage.length >= MAX_TICKER_MESSAGES}
                    onClick={(e) => handleAddSingleMessage(e)}
                  >
                    <img src={addCircle} className="actionIcon addAction" alt={t("ADD")}  title={t("ADD")}/>&nbsp;&nbsp;
                    <FormattedMessage id='ADD_TICKER_MESSAGE_ANOTHER' />
                  </button>
                </div>
                {submitted && modalError && (
                  <div className='modal-error invalid-feedback d-block fw-bold text-center'>
                    {modalError}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='ADD_TICKER_MESSAGE' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TickerMessage;
